/* ================================================================ */
// MAP SELECTORS | index.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import createCachedSelector from 're-reselect';
import {createSelector} from 'reselect';
import PropTypes from 'prop-types';
import {isNullOrUndefined} from 'util';
//import isEqual from 'lodash.isEqual';
// Theme Setup
import {getTheme} from '@myglobe/core/dist/styles/theme';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { VisEngineTypes, LayerTypes } from '@myglobe/core/dist/types';
// Selectors
import {getLayersById, getLayersByHash, getDatasetsById, getDatasetsByHash} from '../Data';
/* ========================================== */
// LOADING
/* ========================================== */
/**
 * Get Loading Status
 * ------------------
 * Determines current loading state either
 * by all keys within in the loading state
 * or according to a given specific loading key
 *
 * @param {object} store reducer store
 * @param {string} checkState loading key to check
 */
export const getMapLoadingStatus = (store, checkState) => (checkState && store.Map.loading[checkState] !== null) ? store.Map.loading[checkState] : Object.values(store.Map.loading).includes(true);
export const getMapLoadingStatusSelector = statuses => {
    return createSelector(
        store=>store.Map.loading,
        (loading)=>{
            const loadingKeys = Object.keys(loading);
            const loadingValues = Object.values(loading);
            // Check all statuses exist
            if(statuses.every(status=>loadingKeys.includes(status))) {
                // Get combined loading state of all requested statuses
                // > Loading state is true if one status is found to be loading
                return statuses.some(status=>loading[status] === true);
            } else {
                // Universal loading (all loading statues)
                return loadingValues.includes(true);
            }
        }
    );
};
getMapLoadingStatusSelector.propTypes = {
    statuses: PropTypes.arrayOf(PropTypes.string).isRequired
};
export const getMapStyleURL = store => typeof store.Map.mapStyle === 'string' ? store.Map.mapStyle : store.Map.mapStyle.url;
/* ========================================== */
// MAP
/* ========================================== */
/**
 * Get View State
 * --------------
 * Get current map view state
 *
 * @param {object} store
 */
export const getViewState = store => store.Map.viewState;
/* ========================================== */
// LAYERS
/* ========================================== */
/**
 * Get Active Layers
 * -----------------
 * Returns current layer ids loaded on the map
 *
 * @param {object} store reducer store
 */
export const getActiveLayerIds = store => store.Map.layers;
export const getActiveLayers = createSelector(
    getActiveLayerIds,
    getLayersById,
    getLayersByHash,
    getDatasetsById,
    getDatasetsByHash,
    (activeLayerIds, layerIds, layerHash, datasetIds, datasetHash) => {
        const layerData = activeLayerIds.map(activeLayerId=>{
            if(layerIds.includes(activeLayerId)) {
                let layer = layerHash[activeLayerId];
                let {dataset} = layer;
                if(dataset && datasetIds.includes(dataset)) {
                    layer.config.data = datasetHash[dataset].endpointData || datasetHash[dataset].endpoint;
                }
                return layer;
            }
        });
        const mapboxLayers = layerData.filter(layer=>layer && layer.type.toLowerCase() === VisEngineTypes.MAPBOX);
        const deckLayers = layerData.filter(layer=>layer && layer.type.toLowerCase() === VisEngineTypes.DECKGL);
        console.debug('Map (Selector) | ', 'getActiveLayers -', 'activeLayerIds:', activeLayerIds, 'mapboxLayers:', mapboxLayers, 'deckLayers:', deckLayers);
        return {mapboxLayers, deckLayers};
    }
)/*(
    (_store_, activeLayerIds)=>{console.log(activeLayerIds); return activeLayerIds.join(':');}
)*/;


/* ========================================== */
// JSON DeckGL Configuration
/* ========================================== */
export const getBaseJSONConfig = store => store.Map.jsonConfig;
export const getLayerClasses = store => store.Map.layerClasses;
export const getJSONConfig = createSelector(
    getBaseJSONConfig,
    getLayerClasses,
    (baseConfig, layerClasses) => {
        // Merge base configuration with currently loaded layers
        const jsonConfig = {
            ...baseConfig,
            layers: {...baseConfig.layers, ...layerClasses}
        };
        console.debug('Map (Selector) |', 'getJSONConfig -', 'layerClasses:', layerClasses, 'baseConfig:', baseConfig, 'outputConfig:', jsonConfig);
        return jsonConfig;
    }
);

/*

const getExternalLayerClasses = async (layers) => {
    //const layerIDs = [...new Set(Object.values(payload).map(state=>state.layers).flat())];
    const classes = Array.from(new Set(layers.map(layer=>{
        /*if(LayerTypes.deckgl.layers.includes(layer.type))
            return import('@deckgl/layers');
        */
       /*
        const type = layer.type;
        if(LayerTypes.deckgl.aggregationLayers.includes(type))
            import('@deck.gl/aggregation-layers').then(module=>{return module});
        if(LayerTypes.deckgl.geoLayers.includes(type))
            return import('@deck.gl/geo-layers').then(module=>{return module});
        if(LayerTypes.deckgl.custom.includes(type)) {
            // Attempt fetch of custom layer
            try {
                return require(`@myglobe/core/dist/Map/layers/${type}`).define;
            } catch (e) {
                console.log(e);
            }
        }
        return null;
    })));

    console.log(classes);
    return classes;
};
const types = [...LayerTypes.deckgl.layers, ...LayerTypes.deckgl.aggregationLayers, ...LayerTypes.deckgl.geoLayers, ...LayerTypes.deckgl.custom];
getLayerClasses.propTypes = {
    layers: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.oneOf(types)
    }))
};*/